 const documentTypesConst = {
    RNC: { id: 1, value: 'RNC' },
    CEDULA: { id: 2, value: 'CEDULA' },
    PASAPORTE: { id: 3, value: 'PASAPORTE' },
    CEDULA_MENOR: { id: 4, value: 'CEDULA MENOR' }
};
export default documentTypesConst;